import { Action } from '@ngrx/store';
import { IUserRole } from '../IUserRole';

export enum UserRoleActionTypes {
    LoadUserRoles = '[user_role] Load User Roles',
    SetUserRole = '[user_role] Set Role',
    Reset = '[user_role] Reset'
}

export class Reset implements Action {
    readonly type = UserRoleActionTypes.Reset;
}
export class LoadUserRoles implements Action {
    readonly type = UserRoleActionTypes.LoadUserRoles;
}
export class SetUserRole implements Action {
    constructor(public payload: Array<IUserRole>) {}
    readonly type = UserRoleActionTypes.SetUserRole;
}

export type UserRoleActionsUnion = LoadUserRoles | SetUserRole | Reset;
